import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Amphibian = forwardRef<SVGSVGElement, SvgIconProps>(
  function Amphibian(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M16.749 4c.909 0 1.74.379 2.31 1.001 1.481 1.516 1.196 3.654-.259 5.062 2.986 2.544 3.013 5.955-.415 8.31-3.506 2.436-9.244 2.436-12.777 0-3.324-2.274-3.48-5.711-.416-8.31a4.146 4.146 0 0 1-1.054-1.688c-.36-1.14-.15-2.388.795-3.374A3.172 3.172 0 0 1 7.244 4c2.208 0 3.429 1.922 3.22 4.033 1.065-.109 2-.109 3.09 0C13.32 5.867 14.593 4 16.75 4Zm-.764 2.185a1.402 1.402 0 0 0 0 1.93 1.402 1.402 0 0 0 1.93 0 1.402 1.402 0 0 0 0-1.93 1.402 1.402 0 0 0-1.93 0Zm-7.986 0a1.361 1.361 0 0 0-1.898 0 1.36 1.36 0 0 0 0 1.93c.51.513 1.362.513 1.898 0a1.36 1.36 0 0 0 0-1.93Z" />
        <path d="M15.852 6.961a.936.936 0 0 0 0 1.278.858.858 0 0 0 1.233 0 .936.936 0 0 0 0-1.278.858.858 0 0 0-1.233 0ZM8.135 8.239a.904.904 0 0 0 0-1.278.904.904 0 0 0-1.27 0 .904.904 0 0 0 0 1.278.904.904 0 0 0 1.27 0Z" />
        <path
          d="M6.596 14.8c.465 1.97 2.235 2.956 5.31 2.956 3.074 0 4.904-.985 5.49-2.956"
          stroke="#FFF"
        />
      </SvgIcon>
    )
  },
)

export default Amphibian
